import './Support.scss'
import { Typography, Row, Col, Image, Flex, Collapse } from 'antd'
import MailIcon from "../../assets/icons/mail-icon.svg"
import WhatsappIcon from "../../assets/icons/whatsapp-icon.svg"
import CallIcon from "../../assets/icons/call.svg"
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"
import { FAQ, GLOBAL_CONSTANTS } from '../../constants/constants'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const { Title, Text } = Typography;

const Support = () => {
  const { user } = useSelector((state) => state.auth);
  const [activeKey, setActiveKey] = useState(["1"])

  const panelStyle = {
    marginBottom: 24,
    borderRadius: 8,
    border: "1px solid #D8E4FD",
  };

  const collapseItems = [
    {
      key: '1',
      label: FAQ.Q1.Q,
      children: FAQ.Q1.A,
      style: { ...panelStyle, background: activeKey.includes("1") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '2',
      label: FAQ.Q2.Q,
      children: FAQ.Q2.A,
      style: { ...panelStyle, background: activeKey.includes("2") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '3',
      label: FAQ.Q3.Q,
      children: FAQ.Q3.A,
      style: { ...panelStyle, background: activeKey.includes("3") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '4',
      label: FAQ.Q4.Q,
      children: FAQ.Q4.A,
      style: { ...panelStyle, background: activeKey.includes("4") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '5',
      label: FAQ.Q5.Q,
      children: FAQ.Q5.A,
      style: { ...panelStyle, background: activeKey.includes("5") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '6',
      label: FAQ.Q6.Q,
      children: FAQ.Q6.A,
      style: { ...panelStyle, background: activeKey.includes("6") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '7',
      label: FAQ.Q7.Q,
      children: FAQ.Q7.A,
      style: { ...panelStyle, background: activeKey.includes("7") ? "#F5F8FF" : "#ffffff" },
    },
    {
      key: '8',
      label: FAQ.Q8.Q,
      children: FAQ.Q8.A,
      style: { ...panelStyle, background: activeKey.includes("8") ? "#F5F8FF" : "#ffffff" },
    },

  ];

  return (
    <div className='support-container'>
      <Title level={3}>Contact</Title>
      <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
        <Col xs={10} lg={6}>
          <div className="contact-mode-cards">
            <Image src={MailIcon} alt='Mail' preview={false} style={{ height: 20, width: 20 }} />
            <Flex vertical gap={2}>
              <Title level={5} >Email</Title>
              <Text>{GLOBAL_CONSTANTS.SUPPORT_EMAIL}</Text>
            </Flex>
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <div className="contact-mode-cards">
            <Image src={WhatsappIcon} alt='Whatsapp' preview={false} style={{ height: 20, width: 20 }} />
            <Flex vertical gap={2}>
              <Title level={5} >Whatsapp</Title>
              <Text>{GLOBAL_CONSTANTS.WHATSAPP_NUM}</Text>
            </Flex>
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <div className="contact-mode-cards">
            <Image src={CallIcon} alt='Call' preview={false} style={{ height: 20, width: 20 }} />
            <Flex vertical gap={2}>
              <Title level={5}>Call RM</Title>
              <Text>{user?.RMuser?.UserDetailsView?.mobile}</Text>
            </Flex>
          </div>
        </Col>
      </Row>
      <Title level={3} style={{ marginTop: 40 }}>FAQ</Title>
      <Collapse
        bordered={false}
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
        expandIcon={({ isActive }) => (
          <Image
            src={ArrowDownIcon}
            alt='Arrow'
            preview={false}
            style={{
              transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease'
            }}
          />
        )}
        expandIconPosition='end'
        style={{ background: "#ffffff", width: '100%' }}
        items={collapseItems}
      />
    </div>
  )
}

export default Support